
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useRoleAccess } from '@/hooks/useRoleAccess';

const AppLanding = () => {
  const navigate = useNavigate();
  const { loading } = useAuth();
  const { isAdmin, isCoordinator, isCustomer } = useRoleAccess();

  useEffect(() => {
    if (loading) return;

    // Redirect based on user role
    if (isAdmin()) {
      navigate('/app/hq/dashboard', { replace: true });
    } else if (isCoordinator()) {
      navigate('/app/staff/dashboard', { replace: true });
    } else if (isCustomer()) {
      navigate('/app/patient/dashboard', { replace: true });
    } else {
      // Fallback for users without defined roles - default to patient
      navigate('/app/patient/dashboard', { replace: true });
    }
  }, [loading, isAdmin, isCoordinator, isCustomer, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-juv-cream-white">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-juv-terracotta"></div>
      </div>
    );
  }

  return null;
};

export default AppLanding;
